import {
  ContentWide,
  ContentWrapper,
} from 'volto-essvoltocomponents/components/Layout';
import PageSection from '../../Layout/PageSection';
import { CTABanner } from '../../Molecules/CTABanner';

const CTABannerCompShowcase = () => {

  return (
    <div>
      {/* CTA Banner Component */}
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>          
            <h2>CTA Banner - Call to Action</h2>
            <p>Full-width call-to-action banners with responsive layouts. Perfect for About Us, Contact, or promotional sections.</p>
            <h4>With background color neutral-01 and default values for button variant ("positive md"), minHeight 300px and horizontal alignment center)</h4>
          </ContentWide>          
         </ContentWrapper>
      </PageSection>
      
      <CTABanner
        title="Ready to Get Started?"
        description="Join thousands of organizations using our platform to build amazing experiences. Start your free trial today and see the difference."
        ctaText="Start Free Trial"
        ctaTo="/signup"
        backgroundColor="var(--color-neutral-01)"
      />

      <PageSection>
        <ContentWrapper>
          <ContentWide>         
            <h4>With background color set to "--color-primary-01" and horizontal alignment left and button variant "negative lg"</h4>
          </ContentWide>          
         </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Need Help?"
        description="Our support team is here to assist you with any questions or issues you may have."
        ctaText="Contact Support"
        ctaTo="/contact"
        ctaVariant="negative"
        backgroundColor="var(--color-primary-01)"
        alignment="left"
        titleColor="var(--color-secondary-01)"
        textColor="var(--color-secondary-01)"
      />

      <PageSection>
        <ContentWrapper>
          <ContentWide>      
            <h4>With gradient color background "positive-01" to "positive-02" with default direction (to right) and button variant "negative lg"</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Transform Your Workflow"
        description="Streamline your processes and boost productivity with our innovative solutions."
        ctaText="Get Started"
        ctaHref="https://example.com"
        ctaVariant="negative"
        gradientStartColor="var(--color-primary-01)"
        gradientEndColor="var(--color-primary-02)"
        gradientDirection="to right"
        variant="gradient"
        alignment="center"
      />
         
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>   
            <h4>With gradient color background "positive-01" to "positive-02" and direction set to left</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Transform Your Workflow"
        description="Streamline your processes and boost productivity with our innovative solutions."
        ctaText="Get Started"
        ctaHref="https://example.com"
        ctaVariant="negative"
        gradientStartColor="var(--color-primary-01)"
        gradientEndColor="var(--color-primary-02)"
        gradientDirection="to left"
        variant="gradient"
        alignment="center"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>   
            <h4>With gradient color background "positive-01" to "positive-03" and direction set to top</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Transform Your Workflow"
        description="Streamline your processes and boost productivity with our innovative solutions."
        ctaText="Get Started"
        ctaHref="https://example.com"
        ctaVariant="negative"
        gradientStartColor="var(--color-primary-01)"
        gradientEndColor="var(--color-primary-02)"
        gradientDirection="0"
        variant="gradient"
        alignment="center"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>   
            <h4>With Background Image and custom values for height and text color</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Discover the Future of Science"
        description="Join us in pushing the boundaries of research and innovation. Our state-of-the-art facilities and world-class team are ready to collaborate with you."
        ctaText="Explore Opportunities"
        ctaTo="/opportunities"
        ctaVariant="negative"
        backgroundImage="https://images.unsplash.com/photo-1534996858221-380b92700493?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        textColor="var(--color-secondary-02)"
        minHeight="500px"
        alignment="center"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>   
            <h4>With CTA size small</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Ready to Get Started?"
        description="Join thousands of organizations using our platform to build amazing experiences. Start your free trial today and see the difference."
        ctaText="Start Free Trial"
        ctaTo="/signup"
        ctaSize="sm"
      />
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>   
            <h4>With alignment center</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Discover the Future of Science"
        description="Join us in pushing the boundaries of research and innovation. Our state-of-the-art facilities and world-class team are ready to collaborate with you."
        ctaText="Explore Opportunities"
        ctaTo="/opportunities"
        ctaVariant="negative"
        backgroundImage="https://images.unsplash.com/photo-1534996858221-380b92700493?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        textColor="var(--color-secondary-02)"
        minHeight="500px"
        alignment="center"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>   
            <h4>With alignment left</h4>
          </ContentWide>          
        </ContentWrapper>
      </PageSection>

      <CTABanner
        title="Discover the Future of Science"
        description="Join us in pushing the boundaries of research and innovation. Our state-of-the-art facilities and world-class team are ready to collaborate with you."
        ctaText="Explore Opportunities"
        ctaTo="/opportunities"
        ctaVariant="negative"
        backgroundImage="https://images.unsplash.com/photo-1534996858221-380b92700493?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        textColor="var(--color-secondary-02)"
        minHeight="500px"
        alignment="left"
      />

    </div>         
  );
};


export default CTABannerCompShowcase;
